import React from 'react'
import '../../stylesheet/banner.css'

export default function Banner({SeeAll}) {
  return (
    <div>

    <div style={{ width: '100%', height: '60px', display: 'flex', flexDirection: 'row', margin: '0px', backgroundColor: '#272a2d',justifyContent: 'space-between' }}>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
            
        <button onClick={() => { SeeAll(true) }} className="custom-button">
          Latest Movies
        </button>
        <button onClick={() => { SeeAll(false) }} className="custom-button">
          Recommended
        </button>

          
        </div>
    

    </div>

    </div>
  )
}
